import { Card, IconButton, Grid, Typography, useTheme } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

const CardListAlerta = ({item,onDeletedAlerta}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    return (
        <Card sx={{background: isDarkMode ? '#2d3a52' : '#fff', border: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`, padding: 2,borderRadius:2,boxShadow: 4}} key={item?.id}>
            <Grid container spacing={1} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Grid item xs={8.5}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold',textAlign: 'center', fontSize: 12}}>
                        {item?.tipo_alerec}
                    </Typography>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold',textAlign: 'center'}}>
                        {item?.tipoIdNombre}
                    </Typography>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>
                        {item?.textAviso_alerec}</Typography>
                </Grid>
                <Grid item xs={1.5}>
                    <IconButton sx={{background: isDarkMode ? '#1F2A40' : 'transparent', boxShadow:1}} onClick={()=>onDeletedAlerta(item?.id)}>
                        <DeleteOutlineOutlinedIcon sx={{color: isDarkMode ? '#ff6b6b' : 'red'}} />
                    </IconButton>
                </Grid>
            </Grid>
        </Card>
    )
}

export default CardListAlerta;